export default __webpack_public_path__ + "static/media/uiSelect.c300c527.mp3";